var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hamburguer" }, [
    _c("input", {
      attrs: { type: "checkbox" },
      domProps: { value: _vm.menuOpened },
      on: {
        change: function($event) {
          _vm.changeMenuOpened(!_vm.menuOpened)
        }
      }
    }),
    _vm._v(" "),
    _c("span"),
    _vm._v(" "),
    _c("span"),
    _vm._v(" "),
    _c("span"),
    _vm._v(" "),
    _c("div")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e4292aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4292aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar/Burguer.vue
// module id = null
// module chunks = 